import React from 'react';
import { Route } from 'react-router-dom';

// LMS Layout and Dashboard
import LMSLayout from './LMSLayout';
import LMSDashboard from './LMSDashboard';

// LMS Classes components
import ClassesListPage from '../../prototypes/lms/classes/ClassesListPage';
import ClassDetailPage from '../../prototypes/lms/classes/ClassDetailPage';
import ClassCreatePage from '../../prototypes/lms/classes/ClassCreatePage';
import ClassEditPage from '../../prototypes/lms/classes/ClassEditPage';
import ActiveClasses from '../../prototypes/lms/classes/ActiveClasses';

// LMS Courses components
import CoursesPage from '../../prototypes/lms/courses/CoursesPage';
import CourseDetailPage from '../../prototypes/lms/courses/CourseDetailPage';

// LMS Modules
import ModulesPage from './modules/ModulesPage';
import ModuleDetailPage from './modules/ModuleDetailPage';
import ModuleEditPage from './modules/ModuleEditPage';

// Training Operations components
export const lmsRoutes = (
  <Route path="/lms" element={<LMSLayout />}>
    <Route index element={<LMSDashboard />} />
    
    {/* Courses Routes */}
    <Route path="courses" element={<CoursesPage />} />
    <Route path="courses/new" element={<CoursesPage />} />
    <Route path="courses/:id" element={<CourseDetailPage />} />
    
    {/* Modules Routes */}
    <Route path="modules" element={<ModulesPage />} />
    <Route path="modules/new" element={<ModuleEditPage />} />
    <Route path="modules/:moduleId" element={<ModuleDetailPage />} />
    <Route path="modules/:moduleId/edit" element={<ModuleEditPage />} />
    
    {/* Classes Routes */}
    <Route path="classes" element={<ClassesListPage />} />
    <Route path="classes/new" element={<ClassCreatePage />} />
    <Route path="classes/:id" element={<ClassDetailPage />} />
    <Route path="classes/:id/edit" element={<ClassEditPage />} />
    <Route path="classes/active" element={<ActiveClasses />} />
    <Route path="classes/upcoming" element={<ClassesListPage defaultFilter="upcoming" title="Upcoming Classes" />} />
    <Route path="classes/completed" element={<ClassesListPage defaultFilter="completed" title="Completed Classes" />} />
    
    
  </Route>
);
